module.exports = {"pageHeader":"Om Deveo"}


//////////////////
// WEBPACK FOOTER
// ./src/app/about/lang/da.lang.json
// module id = 331
// module chunks = 1